import axios from "axios";
import {createSlice} from '@reduxjs/toolkit';
import {firestore} from '../../config/firebaseConfig';
import {toast} from 'react-toastify';
import {isFunction} from "lodash";


const initialState = {
    isLoading: false,
    error: false,
    isSucces: false,
    publish: [],
    db: {
        isLoading: false,
        error: false,
        isSucces: false,
    },

    facebook: {
        isLoading: false,
        error: false,
        isSucces: false,
    },
    instagram: {
        isLoading: false,
        error: false,
        isSucces: false,
    },
    telegram: {
        isLoading: false,
        error: false,
        isSucces: false,
    },
    whatsapp: {
        isLoading: false,
        error: false,
        isSucces: false,
    },

    notifications: null
};

const slice = createSlice({
    name: 'publish',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isSucces = false;
            state.isLoading = true;
            state.error = false;
        },

        startDbLoading(state) {
            state.db.isSuccess = false;
            state.db.isLoading = true;
            state.db.error = false;
        },

        startFacebookLoading(state) {
            state.facebook.isSuccess = false;
            state.facebook.isLoading = true;
        },

        startInstagramLoading(state) {
            state.instagram.isSucces = false;
            state.instagram.isLoading = true;
        },

        startTelegramLoading(state) {
            state.telegram.isSucces = false;
            state.telegram.isLoading = true;
        },

        startWhatsAppLoading(state) {
            state.whatsapp.isSucces = false;
            state.whatsapp.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
            console.log(action.payload);
        },

        hasDbError(state, action) {
            state.db.isLoading = false;
            state.db.error = action.payload;
            console.log(action.payload);
        },

        hasFacebookError(state, action) {
            state.facebook.isLoading = false;
            state.facebook.error = action.payload;
            console.log(action.payload);
        },

        hasInstagramError(state, action) {
            state.instagram.isLoading = false;
            state.instagram.error = action.payload;
            console.log(action.payload);
        },

        hasTelegramError(state, action) {
            state.telegram.isLoading = false;
            state.telegram.error = action.payload;
            console.log(action.payload);
        },

        hasWhatsAppError(state, action) {
            state.whatsapp.isLoading = false;
            state.whatsapp.error = action.payload;
            console.log(action.payload);
        },


        hasSuccess(state) {
            state.isLoading = false;
            state.isSucces = true;
        },

        hasDbSuccess(state) {
            toast.success("Sauvegarde de la publication reussie")
            state.db.isLoading = false;
            state.db.isSucces = true;
        },

        hasFacebookSuccess(state) {
            toast.success("Publication Facebook reussie")
            state.facebook.isLoading = false;
            state.facebook.isSucces = true;
        },

        hasInstagramSuccess(state) {
            toast.success("Publication Instagram reussie")
            state.instagram.isLoading = false;
            state.instagram.isSucces = true;
        },

        hasTelegramSuccess(state) {
            toast.success("Publication Telegram reussie")
            state.telegram.isLoading = false;
            state.telegram.isSucces = true;
        },

        hasWhatsAppSuccess(state) {
            toast.success("Publication WhatsApp reussie")
            state.whatsapp.isLoading = false;
            state.whatsapp.isSucces = true;
        },


    }
});


export default slice.reducer;

const FACEBOOK_ID = process.env.REACT_APP_FACEBOOK_APP_ID
const FACEBOOK_TOKEN = process.env.REACT_APP_FACEBOOK_ACCESS_TOKEN

const INSTAGRAM_ID = process.env.REACT_APP_INSTAGRAM_ID
const INSTAGRAM_TOKEN = process.env.REACT_APP_INSTAGRAM_ACCESS_TOKEN

const TELEGRAM_TOKEN = process.env.REACT_APP_TELEGRAM_BOT_TOKEN
const TELEGRAM_CHANEL = process.env.REACT_APP_TELEGRAM_MY_CHANNEL_NAME
//------------------------------------------------------------------
export function makeFacebookPublish({imageUrl, Description}) {

    return async (dispatch) => {
          //  access_token: `EAAFXXmvQv3IBAErkTI6vuXJeqbZCAT9TZAAyuATpu6YNIgsSjKF5mwqPSEy8YQHoHkf6miEEVcnZCA0PN5WwDPMqDBXmRIzXfczsZCNTT7fu26ZClxvv79NU2ZCNdXQou5fbSHQoYSFwS6Jb00st9wUIFQ70j1xsOjGETBH1Il1iT6xyQyXGy6D9m9LCouobYZD`,
         //  access_token: `EAAPkZCmhmrfABAG0HMegbndsB4WUPl52jmJWacZAxuovySyIsp7rZCPrDwHqMs18lrOXt0wES2adMK4IhrAYyZCA0jrIhYN8vBGs7zu4E8ZB1rkTf73AQk5Y8yRhBdwYUY0k1JUXPeZCITCVXkgKfRQJSTHOzceIBsvDUlF1KZB3UDafUD75jfA`,
        const token_facebbok = `${FACEBOOK_TOKEN}`
        // const baseUrl = "https://graph.facebook.com/v12.0/108221408277641";
        // const baseUrl =`https://graph.facebook.com/v12.0/327169511447113`;
        const baseUrl =`https://graph.facebook.com/v12.0/${FACEBOOK_ID}`;

        console.log(baseUrl)

        const configFace = {
            method: 'post',
            url: `${baseUrl}/photos`,
            data: {
                message: `${Description}`,
                url: `${imageUrl}`,
                //  access_token: `EAAFXXmvQv3IBAErkTI6vuXJeqbZCAT9TZAAyuATpu6YNIgsSjKF5mwqPSEy8YQHoHkf6miEEVcnZCA0PN5WwDPMqDBXmRIzXfczsZCNTT7fu26ZClxvv79NU2ZCNdXQou5fbSHQoYSFwS6Jb00st9wUIFQ70j1xsOjGETBH1Il1iT6xyQyXGy6D9m9LCouobYZD`,
                //  access_token: `EAAPkZCmhmrfABAG0HMegbndsB4WUPl52jmJWacZAxuovySyIsp7rZCPrDwHqMs18lrOXt0wES2adMK4IhrAYyZCA0jrIhYN8vBGs7zu4E8ZB1rkTf73AQk5Y8yRhBdwYUY0k1JUXPeZCITCVXkgKfRQJSTHOzceIBsvDUlF1KZB3UDafUD75jfA`,
                // access_token: `${FACEBOOK_TOKEN}`,
                access_token: token_facebbok,
            }
        }
        try {
            dispatch(slice.actions.startFacebookLoading());
            await axios(configFace)

            dispatch(slice.actions.hasFacebookSuccess({imageUrl, Description}));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasFacebookError(error));
        }
    }
}

//------------------------------------------------------------------
export function makeInstagramPublish({imageUrl, Description}) {
    return async (dispatch) => {
        //  const token = `EAAFXXmvQv3IBAMZCZAUCDtXD7ZA016Y1SzUT1Yg9MWpH2J5ZClzW1U3A6Sr02vFBUejhcJtkZCCdV8lowYnSZBrOP7iZCa3ZAqJKVrgAZCA9EVYQakkJzIZB77kSZCUbXYLwZCIuoONs6yuoNPZCZBtMxRny0ivknhq8bEPZByGZBzOkwWOWzBqT8px3ZC89ZB`
        // const token = `EAAJFgZArOy6YBACMnv02WHQNFMwZC1ZCn0MdcksVJgZByiZCcpSq7eRXUG4wkuX79pG9ZBzD6JGdCjCEZA0EcZBlb3aZCKA7nC34UlayIBfCHZB1Yg46hEA8RcJWZCKTXfGz1FTHCt3lXCTLzKwFYAGzOTg3KnR7zFK5I1eP5YTVdAB4F4ZBMDCZCdg0U`
        const token = `${INSTAGRAM_TOKEN}`
        //  const baseUrl = "https://graph.facebook.com/v12.0/17841449407169115";
        // const baseUrl = "https://graph.facebook.com/v12.0/17841439470049257";
        const baseUrl = `https://graph.facebook.com/v12.0/${INSTAGRAM_ID}`;

        const configInsta = {
            method: 'post',
            url: `${baseUrl}/media`,
            data: {
                image_url: `${imageUrl}`,
                caption: `${Description}`,
                access_token: token
            }
        }
        try {
            dispatch(slice.actions.startInstagramLoading());
            const response = await axios(configInsta)
            console.log(response.data)
            await axios.post(`${baseUrl}/media_publish`, {
                creation_id: response.data.id,
                access_token: token
            })

            dispatch(slice.actions.hasInstagramSuccess({imageUrl, Description}));
        } catch (error) {
            dispatch(slice.actions.hasInstagramError(error));
        }
    }
}

//------------------------------------------------------------------
export function makeTelegramPublish({imageUrl, Description}) {
    return async (dispatch) => {
        //  const baseUrl = "https://api.telegram.org/bot2048656590:AAEYhfgdmd_-9GdrmzIWT1mewF0IV42Fuhc";
        const baseUrl = `https://api.telegram.org/bot${TELEGRAM_TOKEN}`;

        // console.log(baseUrl);

        const MY_CHANNEL_NAME =`${TELEGRAM_CHANEL}`
        //const MY_CHANNEL_NAME ="@DtText"
        const configTele = {
            method: 'post',
            url: `${baseUrl}/sendPhoto`,
            data: {
                chat_id: MY_CHANNEL_NAME,
                photo: imageUrl,
                caption: Description,
            }
        }

        try {
            dispatch(slice.actions.startTelegramLoading());
            await axios(configTele)

            dispatch(slice.actions.hasTelegramSuccess({imageUrl, Description,}));
        } catch (error) {
            dispatch(slice.actions.hasTelegramError(error));
        }
    }
}

//------------------------------------------------------------------
export function makeWhatsAppPublish({imageUrl, Description}) {
    return async (dispatch) => {

        try {
            dispatch(slice.actions.startLoading());


        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    }
}

//------------------------------------------------------------------
export function makePublishToDb({imageUrl, Description, platforms, publishType, ProductId, Title}, callback = null) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startDbLoading());

            await firestore.collection('publish').add({
                ImageUrl: imageUrl,
                Description,
                Platforms: platforms,
                PublishType: publishType,
                CreatedAt: new Date(),
                ProductId,
                Title
            })

            dispatch(slice.actions.hasDbSuccess({imageUrl, Description, platforms, publishType}));

            isFunction(callback) && callback();
        } catch (error) {
            dispatch(slice.actions.hasDbError(error));
        }
    }
}